import * as COM from '../components';
const ststemSetup = [
  /** ------------------------------ 数据字典 ------------------------------ */
  {
    path: '/dict-config',
    component: COM.Layout,
    redirect: '/dict-config/index',
    name: 'sys__dictConfig',
    meta: { label: '数据字典' },
    /** ------------------------------ 二级页面 ------------------------------ */
    children: [
      // 数据字典
      {
        path: 'index',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.DictConfig,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        name: 'dictConfigIndex',
        meta: { label: '数据字典', icon: 'el-icon-document', menuKeyPath: '/dict-config/index' }
      }
    ]
  },
  /** ------------------------------ 基础资料 ------------------------------ */
  {
    path: '/basic-setup',
    component: COM.Layout,
    redirect: '/basic-setup/channel-setting',
    name: 'sys__systemSetup',
    meta: { label: '基础资料' },
    /** ------------------------------ 二级页面 ------------------------------ */
    children: [
      // 渠道设置
      {
        path: 'channel-setting',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.ChannelSetting,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        name: 'channelSetting',
        meta: { label: '渠道设置', icon: 'el-icon-document', menuKeyPath: '/basic-setup/channel-setting' }
      },
      // 新建渠道
      {
        path: '/basic-setup/channel-setting',
        components: {
          bodyView: COM.DetailLayout,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        redirect: '/basic-setup/channel-setting/create',
        name: 'channelCreateInside',
        meta: { label: '渠道设置', insidePageFrom: 'channelSetting' },
        children: [
          {
            path: 'create',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.ChannelCreate,
              appHeader: COM.NavHeader,
              bodyHeader: COM.BodyHeader,
              secondMenu: COM.SecondMenu
            },
            name: 'channelCreate',
            meta: { label: '新建渠道', icon: 'el-icon-document', menuKeyPath: '/basic-setup/channel-setting', authKey: '#channelSetting.add' }
          },
          {
            path: 'edit',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.ChannelCreate,
              appHeader: COM.NavHeader,
              bodyHeader: COM.BodyHeader,
              secondMenu: COM.SecondMenu
            },
            name: 'channelEdit',
            meta: { label: '编辑渠道', icon: 'el-icon-document', menuKeyPath: '/basic-setup/channel-setting', authKey: '#channelSetting.modify' }
          }
        ],
      },
      // 操作日志
      {
        path: 'operation-log',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.OperationLog,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        name: 'operationLog',
        meta: { label: '操作日志', icon: 'el-icon-document', menuKeyPath: '/basic-setup/operation-log' }
      },
      // 店铺管理
      {
        path: 'store-mgr',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.StoreMgr,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        name: 'storeMgr',
        meta: { label: '店铺管理', icon: 'el-icon-document', menuKeyPath: '/basic-setup/store-mgr' }
      },
      // 新增店铺
      {
        path: '/basic-setup/store-mgr',
        components: {
          bodyView: COM.DetailLayout,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        redirect: '/basic-setup/store-mgr/add',
        name: 'addStoreMgrInside',
        meta: { label: '店铺管理', insidePageFrom: 'storeMgr' },
        children: [
          {
            path: 'add',
            components: {
              bodyView: COM.AddStoreMgr,
              appHeader: COM.NavHeader,
              bodyHeader: COM.BodyHeader,
              secondMenu: COM.SecondMenu
            },
            name: 'addStoreMgr',
            meta: { label: '新增店铺', icon: 'el-icon-document', menuKeyPath: '/basic-setup/store-mgr', authKey: '#storeMgr.add' }
          }
        ]
      },
      // 礼品管理
      {
        path: 'gift-management-list',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.GiftManagementList,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        name: 'giftManagementList',
        meta: { label: '礼品管理', icon: 'el-icon-document', menuKeyPath: '/basic-setup/gift-management-list' }
      },
      // 新增礼品，礼品详情
      {
        path: '/basic-setup/gift-management-list',
        components: {
          bodyView: COM.DetailLayout,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        redirect: '/basic-setup/gift-management-list/add',
        name: 'giftAddInside',
        meta: { label: '礼品管理', insidePageFrom: 'giftManagementList' },
        children: [
          {
            path: 'gift-add',
            components: {
              bodyView: COM.GiftAdd,
              appHeader: COM.NavHeader,
              bodyHeader: COM.BodyHeader,
              secondMenu: COM.SecondMenu
            },
            name: 'giftAdd',
            meta: { label: '新增礼品', icon: 'el-icon-document', menuKeyPath: '/basic-setup/gift-management-list', authKey: '#giftManagementList.add' }
          },
          {
            path: 'gift-edit',
            components: {
              bodyView: COM.GiftAdd,
              appHeader: COM.NavHeader,
              bodyHeader: COM.BodyHeader,
              secondMenu: COM.SecondMenu
            },
            name: 'giftEdit',
            meta: { label: '编辑礼品', icon: 'el-icon-document', menuKeyPath: '/basic-setup/gift-management-list', authKey: '#giftManagementList.modify' }
          },
          {
            path: 'gift-detail',
            components: {
              bodyView: COM.GiftDetail,
              appHeader: COM.NavHeader,
              bodyHeader: COM.BodyHeader,
              secondMenu: COM.SecondMenu
            },
            name: 'giftDetail',
            meta: { label: '礼品详情', icon: 'el-icon-document', menuKeyPath: '/basic-setup/gift-management-list', authKey: 'giftManagementList' }
          }
        ]
      },
      // 规则调用管控
      {
        path: 'integral-rule-caller',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.IntegralRuleCaller,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        name: 'integralRuleCaller',
        meta: { label: '规则调用管控', icon: 'el-icon-document', menuKeyPath: '/basic-setup/integral-rule-caller' }
      },
      // 修改手机号
      {
        path: 'modify-mobile',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.ModifyMobile,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        name: 'modifyMobile',
        meta: { label: '修改手机号', icon: 'el-icon-document', menuKeyPath: '/basic-setup/modify-mobile' }
      },
      // 敏感词管理
      {
        path: 'sensitive-words',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.SensitiveWordsMgr,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        name: 'sensitiveWordsMgr',
        meta: { label: '敏感词管理', icon: 'el-icon-document', menuKeyPath: '/basic-setup/sensitive-words' }
      },
    ]
  },
  /** ------------------------------ 权限管理 ------------------------------ */
  {
    path: '/authority-management',
    component: COM.Layout,
    redirect: '/authority-management/account-mgr',
    name: 'sys__authority',
    meta: { label: '权限管理' },
    children: [
      // 主体设置
      {
        path: 'org-list',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.OrgMgrList,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        name: 'orgMgrList',
        meta: { label: '主体设置', icon: 'el-icon-document', menuKeyPath: '/authority-management/org-list' }
      },
      // 添加主体
      {
        path: '/authority-management/org-list',
        components: {
          bodyView: COM.DetailLayout,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        redirect: '/authority-management/org-list/add',
        name: 'addOrgInside',
        meta: { label: '主体设置', insidePageFrom: 'orgMgrList' },
        children: [
          // 添加主体
          {
            path: 'add',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.AddOrg,
              appHeader: COM.NavHeader,
              bodyHeader: COM.BodyHeader,
              secondMenu: COM.SecondMenu
            },
            name: 'addOrg',
            meta: { label: '添加主体', icon: 'el-icon-document', menuKeyPath: '/authority-management/org-list', authKey: '#orgMgrList.add' }
          },
          // 修改主体
          {
            path: 'update',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.AddOrg,
              appHeader: COM.NavHeader,
              bodyHeader: COM.BodyHeader,
              secondMenu: COM.SecondMenu
            },
            name: 'updateOrg',
            meta: { label: '修改主体', icon: 'el-icon-document', menuKeyPath: '/authority-management/org-list', authKey: '#orgMgrList.modify' }
          }
        ]
      },
      // 账号管理
      {
        path: 'account-management',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.AccountManagement,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        name: 'accountManagement',
        meta: { label: '账号管理', icon: 'el-icon-document', menuKeyPath: '/authority-management/account-management' }
      },
      // 新增系统账号
      {
        path: '/authority-management/account-management',
        components: {
          bodyView: COM.DetailLayout,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        redirect: '/authority-management/account-management/add',
        name: 'accountManagementInside',
        meta: { label: '账号管理', insidePageFrom: 'accountManagement' },
        children: [
          // 账号新增
          {
            path: 'add',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.AccountManagementAdd,
              appHeader: COM.NavHeader,
              bodyHeader: COM.BodyHeader,
              secondMenu: COM.SecondMenu
            },
            name: 'accountManagementAdd',
            meta: { label: '账号新增', icon: 'el-icon-document', menuKeyPath: '/authority-management/account-management', authKey: '#accountManagement.add' }
          },
          // 账号编辑
          {
            path: 'edit',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.AccountManagementAdd,
              appHeader: COM.NavHeader,
              bodyHeader: COM.BodyHeader,
              secondMenu: COM.SecondMenu
            },
            name: 'accountManagementEdit',
            meta: { label: '账号编辑', icon: 'el-icon-document', menuKeyPath: '/authority-management/account-management', authKey: '#accountManagement.modify' }
          },
          // 账号详情
          {
            path: 'detail',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.AccountManagementDetail,
              appHeader: COM.NavHeader,
              bodyHeader: COM.BodyHeader,
              secondMenu: COM.SecondMenu
            },
            name: 'accountManagementDetail',
            meta: { label: '账号详情', icon: 'el-icon-document', menuKeyPath: '/authority-management/account-management', authKey: 'orgMgrList' }
          }
        ]
      },
      // 角色管理
      {
        path: 'role-management',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.RoleManagement,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        name: 'roleManagement',
        meta: { label: '角色管理', icon: 'el-icon-document', menuKeyPath: '/authority-management/role-management' }
      },
      // 新增编辑角色
      {
        path: '/authority-management/role-management',
        components: {
          bodyView: COM.DetailLayout,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        redirect: '/authority-management/role-management/add',
        name: 'roleManagementInside',
        meta: { label: '角色管理', insidePageFrom: 'roleManagement' },
        children: [
          // 账号新增
          {
            path: 'add',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.RoleManagementAdd,
              appHeader: COM.NavHeader,
              bodyHeader: COM.BodyHeader,
              secondMenu: COM.SecondMenu
            },
            name: 'roleManagementAdd',
            meta: { label: '角色新增', icon: 'el-icon-document', menuKeyPath: '/authority-management/role-management', authKey: '#roleManagement.add' }
          },
          // 账号编辑
          {
            path: 'edit',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.RoleManagementAdd,
              appHeader: COM.NavHeader,
              bodyHeader: COM.BodyHeader,
              secondMenu: COM.SecondMenu
            },
            name: 'roleManagementEdit',
            meta: { label: '角色编辑', icon: 'el-icon-document', menuKeyPath: '/authority-management/role-management', authKey: '#roleManagement.modify' }
          },
          // 账号详情
          {
            path: 'role-user',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.RoleManagementUser,
              appHeader: COM.NavHeader,
              bodyHeader: COM.BodyHeader,
              secondMenu: COM.SecondMenu
            },
            name: 'roleManagementUser',
            meta: { label: '角色用户', icon: 'el-icon-document', menuKeyPath: '/authority-management/role-management', authKey: 'roleManagement' }
          }
        ]
      },
      // 字典数据
      {
        path: 'dictionary-data',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.DictionaryData,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        name: 'dictionaryData',
        meta: { label: '字典数据', icon: 'el-icon-document', menuKeyPath: '/authority-management/dictionary-data' }
      },
      // 菜单功能
      {
        path: 'menu-management',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.MenuManagement,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        name: 'menuManagement',
        meta: { label: '菜单功能', icon: 'el-icon-document', menuKeyPath: '/authority-management/menu-management' }
      },
    ]
  },
];

export default ststemSetup;
